import React, { useState, useRef, useEffect } from 'react';
import { BsFillChatDotsFill } from 'react-icons/bs';
import { AiFillCloseCircle } from 'react-icons/ai';

import TimeZoneConversions from './TimeZoneConversions';
import CountDown from './CountDown';

import './StoreOpeningTime.css';
import generateLocalTimingObj from './timeZoneConversionsMethods';

function RightSideBar() {
  let rbar = useRef();

  const [popup, setpopup] = useState(false);

  useEffect(() => {
    if (popup) {
      setTimeout(() => {
        setpopup(false);
      }, 60000);
    }
  }, [popup]);

  // function checkDate(ty, d, t1, t2, t3 = null, t4 = null) {
  //   if (ty == 1) {
  //     if ((d >= t1 && d <= t2) || (d >= t3 && d <= t4)) {
  //       window
  //         .open(
  //           "https://api.whatsapp.com/send/?phone=9292300345&text&app_absent=0",
  //           "_blank"
  //         )
  //         .focus();
  //       return;
  //     } else {
  //       setpopup(true);
  //       return;
  //     }
  //   } else {
  //     if (d >= t1 && d <= t2) {
  //       window
  //         .open(
  //           "https://api.whatsapp.com/send/?phone=9292300345&text&app_absent=0",
  //           "_blank"
  //         )
  //         .focus();
  //       return;
  //     } else {
  //       setpopup(true);
  //       return;
  //     }
  //   }
  // }

  // openings for chat according to IST
  const zone = 'Asia/Calcutta';
  const timings = {
    // mon: ["07:59-09:29", "11:59-12:59", "19:59-23:59"],
    mon: [],
    tue: ['08:00-09:30', '16:00-17:00'],
    wed: ['08:00-09:30'],
    thu: ['08:00-09:30', '15:00-17:00'],
    fri: [],
    sat: ['10:00-16:00'],
    sun: ['08:00-10:00'],
  };

  const checkDate = (d, day) => {
    // getting converted timings according to local
    const timeObj = generateLocalTimingObj(
      ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
      timings,
      zone
    );
    // getting current day timings
    const currentDay = timeObj[day];

    /// variable for opened or not
    let opened = false;

    // comparing time dynamically to see opened or not
    currentDay.forEach((time, index) => {
      if (d >= parseInt(time[0]) && d <= parseInt(time[1])) {
        opened = true;
      } else {
        opened = false;
      }
    });

    // checking if opened or not and redering according to
    if (!opened) {
      setpopup(true);
      return;
    } else {
      window
        .open(
          'https://api.whatsapp.com/send?phone=+91%2098679%2010690',
          '_blank'
        )
        .focus();
    }
  };

  return (
    <>
      <div
        className="rightSideBar"
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        {popup && (
          <div ref={rbar} className="rbar__popup p-2">
            <p
              // className="py-1 text-center"
              style={{
                textAlign: 'center',
                paddingTop: '4px',
                paddingBottom: '4px',
              }}
            >
              We will be back on <CountDown timings={timings} zone={zone} />
            </p>
            <p
              className=" small"
              style={{ textAlign: 'right', width: '100%', marginLeft: 'auto' }}
            >
              {/* it shows timezome */}
              Your Timezone:- {Intl.DateTimeFormat().resolvedOptions().timeZone}
            </p>

            <div
              // className="h-auto w-100 bg-white p-2 text-dark"
              style={{
                backgroundColor: 'white',
                padding: '8px',
                width: '100%',
                height: 'auto',
                color: 'black',
              }}
            >
              <TimeZoneConversions
                timings={timings}
                days={['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']}
                zone={zone}
              />
            </div>
          </div>
        )}
        {popup ? (
          <AiFillCloseCircle
            style={{ marginLeft: 'auto', marginRight: '1rem' }}
            fontSize="2.5rem"
            fill="#9dca17"
            onClick={() => setpopup(false)}
          />
        ) : (
          <BsFillChatDotsFill
            style={{ marginLeft: 'auto', marginRight: '1rem' }}
            fontSize="2.5rem"
            fill="#9dca17"
            onClick={() => {
              let a = new Date();
              let hrs = a.getHours();
              let mins = `${a.getMinutes()}`;
              if (mins.length < 2) {
                mins = `0${mins}`;
              }
              let d = parseInt(hrs + '' + mins);
              switch (a.getDay()) {
                // 0 Refers to sunday ,then as follows
                // In first parameter of the checkdate function we need to
                // provide the type, the types were as follows
                // type1 = 2 time slot
                // type2 = 1 time slot
                case 0:
                  setpopup(d, 'sun');
                  break;
                case 1:
                  // checkDate(1, d, 800, 930, 1600, 1700);
                  checkDate(d, 'mon');
                  break;
                case 2:
                  // checkDate(1, d, 800, 930, 1600, 1700);
                  checkDate(d, 'tue');
                  break;
                case 3:
                  // checkDate(2, d, 800, 1030);
                  checkDate(d, 'wed');
                  break;
                case 4:
                  // checkDate(1, d, 800, 930, 1500, 1700);
                  checkDate(d, 'thu');
                  break;
                case 5:
                  // checkDate(1, d, 830, 930, 1500, 1600);
                  checkDate(d, 'fri');
                  break;
                case 6:
                  // checkDate(2, d, 1500, 1630);
                  checkDate(d, 'sat');
                  break;
                default:
                  setpopup(true);
                  break;
              }
            }}
          />
        )}
      </div>
    </>
  );
}

export default RightSideBar;
